<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
     <default-heading text="Edit Customer Integration" class="mt-3">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          to="/customer-integration"
        >
          <i class="fal fa-list" />
        </b-button>

        <b-button
          variant="info"
          class="ml-1"
          :to="`/customer-integration/${customer_integration.id}`"
        >
          <i class="fal fa-eye" />
        </b-button>
      </template>
    </default-heading>

    <div class="mb-3">
      <customer-integration-form
        :customer_integration="customer_integration"
        :submitting-form="submittingForm"
        :error="error"
        @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import CustomerIntegrationModel from '@/models/result/CustomerIntegrationModel'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import CustomerIntegrationForm from '@/components/results/customerintegration/CustomerIntegrationForm.vue'

export default {
  name: 'CustomerIntegrationEdit',
  components: {
    DefaultHeading,
    LoadingOverlay,
    CustomerIntegrationForm
  },
  data () {
    return {
      error: null,
      submittingForm: false,
      loading: true,
      customer_integration_id: this.$route.params.id,
      customer_integration: null,
    }
  },
  mounted () {
    this.fetchCustomerIntegration()
  },
  methods: {
    fetchCustomerIntegration () {
      this.loading = true
      const model = new CustomerIntegrationModel({ id: this.customer_integration_id })
      model.fetch().then(() => {
        this.customer_integration = model
        this.loading = false
      }).catch(err => {
        console.error('Error fetching customer integration:', err)
        this.loading = false
        this.error = 'Unable to load customer integration data'
      })
    },

    async submit (form_data) {
      this.error = null
      this.submittingForm = true

      try {
        this.customer_integration.set(form_data)
        await this.customer_integration.save()

        this.$bvToast.toast('Customer Integration Updated', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.$router.push('/customer-integration')
      } catch (err) {
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please contact an administrator'
        }
      }

      this.submittingForm = false
    }
  }
}
</script>
